<template>
  <div>
    <strong class="title">
      {{ i18n.t('components.image_upload.search_image') }}
    </strong>
    <form>
      <div class="row">
        <div class="col-md-9 col-sm-12">
          <text-input :value="imageQuery" :show-label="false" input-id="stock-image-query-field"
                      :help-text="i18n.t('components.image_upload.search_image_hint')"
                      @changed="updateImageQuery" />
        </div>
        <div class="col-md-3 col-sm-12 mb-sm-3">
          <submit-button :label="i18n.t('search')" class="w-100" @click="searchImage" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SubmitButton from '@/components/buttons/submit-button'
import TextInput from '@/components/inputs/text-input'

export default {
  components: { SubmitButton, TextInput },

  props: {
    value: {
      type: String,
      required: false
    }
  },

  emits: ['search-image'],

  data() {
    return {
      imageQuery: this.value
    }
  },

  methods: {
    searchImage() {
      this.$emit('search-image', this.imageQuery)
    },

    updateImageQuery(newImageQuery) {
      this.imageQuery = newImageQuery
    }
  }
}
</script>
